module.exports = __webpack_public_path__ + "img/Inflammation-PDAC_GSE111672.7b1a4c96.png";